import Highcharts from 'highcharts';

export const figure36 = {

  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'bar',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    style: {
      fontFamily: 'Montserrat'
    }
  },

  colors: ['#5b9bd5'],

  credits: {
    enabled: false
  },
  title: {
    text: null
  },
  subtitle: {
    text: null
  },

  plotOptions: {
    series: {
      borderWidth: 0,
      marker: {
        symbol: 'circle',
        enabled: false,
        states: {
          hover: {
            enabled: true,
            radius: 5
          }
        }
      }
    }
  },

  exporting: {
    enabled: false
  },


  xAxis: [{
    categories: [
      "Mundo",
      "África septentrional y Asia occidental",
      "África subsahariana",
      "Oceanía (excluidas Australia y Nueva Zelandia)",
      "América del Norte y Europa",
      "América Latina y el Caribe",
      "Asia oriental y Asia sudoriental",
      "Asia central y Asia meridional",
      "Australia y Nueva Zelandia",
    ],
    lineColor: "#d7d7d7",
    tickColor: "#d7d7d7",
    tickLength: 16,
    labels: {

      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      }
    },
  }],
  yAxis: [{ // Primary yAxis
    labels: {
      format: '{value}%',
      //format: '{value}',
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    gridLineWidth: 2,
    max: 25,
    min: 0,
    tickInterval: 5,
    title: {
      text: null,
      style: {
        color: Highcharts.getOptions().colors[1]
      }
    }
  }],
  tooltip: {
    shared: true,
    useHTML: true,
    hideDelay: 500,
    backgroundColor: null,
    borderWidth: 0,
    shadow: false,
    style: {
      padding: 0
    }
  },
  legend: {
    enabled: false,
  },

  series: [{
    name: 'Porcentaje de pérdida de alimentos por región',
    tooltip: {
      valueSuffix: '%'
    },
    dataLabels: {
      enabled: false,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }

    },
    data: [
        {y: 13.8, color: '#ffc000'},
        {y: 10.8, color: '#5b9bd5'},
        {y: 14.0, color: '#5b9bd5'},
        {y: 8.9, color: '#5b9bd5'},
        {y: 15.7, color: '#5b9bd5'},
        {y: 11.6, color: '#5b9bd5'},
        {y: 7.8, color: '#5b9bd5'},
        {y: 20.7, color: '#5b9bd5'},
        {y: 5.8, color: '#5b9bd5'}
    ]
  }]

}
